import type {ReactElement} from 'react';
import {useContext} from 'react';
import {Button, IconPlacement, ButtonSize, ButtonType} from '@Components/button';
import {isUserLoggedIn} from '@Libraries/user.library';
import {useAppSelector} from '@/hooks';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import {selectEmailMakerIsSharedInTeam} from '@EmailMakerReact/reducers/email-maker-publish-state-reducer';
import {EmailMakerShareInTeamPopup} from '@EmailMakerReact/components/email-maker-share-in-team-popup/email-maker-share-in-team-popup';

export function ShareButton(): ReactElement | null {
  const {store} = useContext(emailMakerContext);
  const isSharedInTeam = useAppSelector(selectEmailMakerIsSharedInTeam);

  if (!isUserLoggedIn() || !store.doesTemplateBelongToUser) {
    return null;
  }

  const shareIcon = isSharedInTeam ? 'icon-group-add' : 'icon-lock';

  const selector = <Button type={ButtonType.SECONDARY} onDark size={ButtonSize.MEDIUM} text={window.i18next.t('pmwjs_share')} icon={shareIcon} iconPlacement={IconPlacement.LEFT} />;

  if (!store.idEmailMarketingCampaign) {
    return selector;
  }

  return <EmailMakerShareInTeamPopup selector={selector} idEmailMarketingCampaign={store.idEmailMarketingCampaign} isSharedInTeam={isSharedInTeam} />;
}
